import React, { Component } from 'react'
import { Container, TextButton } from '@jsluna/react'
import PropTypes from 'prop-types'
import Report from 'powerbi-report-component'
import { withRouter } from 'react-router-dom'
import { Redirect } from 'react-router'

class ReportViewer extends Component {
  constructor(props) {
    super(props)
    this.reportViewerBoxRef = React.createRef()
    this.extraSettings = {
      filterPaneEnabled: false,
      navContentPaneEnabled: true,
      background: 1 // 0: white, 1: transparent
    }
    this.state = { dimensions: { width: window.innerWidth, height: (window.innerHeight * 0.85) } }
  }

  componentWillMount() {
    if (!this.props.embeddedReport) {
      this.props.history.push('/reporting')
    } else {
      this.createReportFilter()
    }
  }

  componentDidMount() {
    window.addEventListener('resize', this.updateDimensions)
  }

  onReportLoad = (report) => {
    if (this.state.filter) {
      report.setFilters([this.state.filter])
        .then(this.reportFilteringFinished(report))
        .catch(error =>
          this.setState({ error })
        )
    }
  }

  getReportStyle = () => {
    const dimensions = this.state.dimensions
    return {
      width: dimensions.width,
      height: dimensions.height }
  }

  createReportFilter = () => {
    const filter = {
      $schema: 'http://powerbi.com/product/schema#basic',
      target: {
        table: {},
        column: {}
      },
      operator: {},
      values: []
    }

    if (this.props.reportType && this.props.reportType.subReport.filter) {
      const reportFilter = this.props.reportType.subReport.filter

      filter.target.table = reportFilter.filterTable
      filter.target.column = reportFilter.filterColumn
      filter.operator = reportFilter.filterOperator
      const filterValue = this.props.selectedReportRow[reportFilter.filterValue]
      filter.values = [filterValue]
      this.setState({ filter })
    }
  }

  // filterValueToInt ensures the filterValue is an integer, as the datatype in Power BI dataset must match filterValue type supplied
  filterValueToInt = (filterValue) => {
    if (typeof filterValue === 'string') {
      return parseInt(filterValue, 10)
    }
    return filterValue
  }

  reportFilteringFinished = (report) => {
    this.report = report
    this.props.viewedEmbeddedReport()
  }

  updateDimensions = () => {
    this.setState({ dimensions: { width: window.innerWidth, height: (window.innerHeight * 0.85) } })
  }

  goBack = () => {
    this.props.clearEmbeddedReport()
    this.props.history.push('/reporting')
  }

  render() {
    if (this.props.embeddedReport) {
      return (
        <div className="ln-u-soft-top">
          <Container>
            <TextButton onClick={this.goBack}>Back to list</TextButton>
          </Container>
          <div ref={this.reportViewerBoxRef} style={{ border: 'none' }}>
            <Report
              embedType="report"
              tokenType="Embed"
              accessToken={this.props.embeddedReport.embedToken.token}
              embedUrl={this.props.embeddedReport.embedUrl}
              embedId={this.props.embeddedReport.id}
              extraSettings={this.extraSettings}
              permissions="View"
              style={this.getReportStyle()}
              onLoad={this.onReportLoad}
            />
          </div>
        </div>
      )
    }
    return <Redirect to={'/reporting'} />
  }
}

ReportViewer.propTypes = {
  embeddedReport: PropTypes.shape({ embedToken: PropTypes.shape({ token: PropTypes.string }), embedUrl: PropTypes.string, id: PropTypes.string }),
  selectedReportRow: PropTypes.object, // eslint-disable-line react/forbid-prop-types
  reportType: PropTypes.shape({ subReport: PropTypes.object.isRequired }).isRequired,
  history: PropTypes.shape({ push: PropTypes.func.isRequired }).isRequired,
  clearEmbeddedReport: PropTypes.func.isRequired,
  viewedEmbeddedReport: PropTypes.func.isRequired
}

ReportViewer.defaultProps = {
  selectedReportRow: null,
  embeddedReport: null
}

export default withRouter(ReportViewer)



// WEBPACK FOOTER //
// ./src/components/ReportViewer/ReportViewer.jsx